import React from "react";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { CSSTransition } from "react-transition-group";
import "./Footer.css";

const FaqItem = ({ faq, isSelected, onSelected }) => {
  return (
    <div className="flex flex-col  gap-[20px] py-2  relative">
      <div
        onClick={onSelected}
        className="flex flex-row justify-between  gap-5 items-center"
      >

        <h3 className="text-white font-walsheimCon text-[17px] capitalize leading-[26px] font-extrabold">
          {faq.question}
        </h3>

        {isSelected ? (
          <FiMinusCircle
            size={20}
            className="duration-300 hover:scale-90  cursor-pointer"
          />
        ) : (
          <FiPlusCircle
            size={20}
            className="duration-300 hover:scale-90   cursor-pointer"
          />
        )}
      </div>
      <div >
        <CSSTransition
          in={isSelected}
          timeout={1000}
          classNames="faq"
          unmountOnExit
        >
          <div className="flex flex-col  items-start justify-center">
            {faq.answer.map((navlinks, index) => (
              <li
                className="text-white w-[220px] font-walsheimMed leading-[26px] font-light text-sm"
                key={index}
              >
                {navlinks}
              </li>
            ))}
          </div>
        </CSSTransition>
      </div>

    </div>
  );
};

export default FaqItem;
